import { useEffect, useState } from 'react';
import cn from 'classnames';
import { IconButton, Typography, useDevice } from 'seagull';
import { WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import styles from "./FormlingContainer.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FormlingContainer(_ref) {
  let {
    title,
    children,
    togglePanelView = false,
    isOpen = false,
    setIsOpen,
    testId
  } = _ref;
  const [showChildren, setShowChildren] = useState(!togglePanelView || isOpen);
  const {
    isMobileDevice
  } = useDevice();
  useEffect(() => {
    if ((!togglePanelView || isOpen) !== showChildren) {
      setShowChildren(!togglePanelView || isOpen);
    }
    // eslint-disable-next-line react-hooks-static-deps/exhaustive-deps
  }, [isOpen, togglePanelView]);
  function toggle() {
    if (togglePanelView) {
      setShowChildren(!showChildren);
      setIsOpen === null || setIsOpen === void 0 || setIsOpen(!showChildren);
    }
  }
  return /*#__PURE__*/_jsxs("section", {
    className: cn(styles.container, {
      [styles.mobile]: isMobileDevice
    }),
    children: [/*#__PURE__*/_jsxs("div", {
      className: cn(styles.titleContainer, togglePanelView && styles.clickableHeader),
      onClick: toggle,
      "data-testid": testId && "".concat(testId, "-header"),
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        weight: "normal",
        className: styles.title,
        children: title
      }), togglePanelView && /*#__PURE__*/_jsx("span", {
        className: styles.menuButtonContainer,
        children: /*#__PURE__*/_jsx(IconButton, {
          children: showChildren ? /*#__PURE__*/_jsx(WideArrowUpward, {}) : /*#__PURE__*/_jsx(WideArrowDownward, {})
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      hidden: !showChildren,
      "data-testid": testId && "".concat(testId, "-content"),
      className: styles.content,
      children: children
    })]
  });
}